// eslint-disable-next-line no-undef
const ENV_API_URL = process.env.REACT_APP_API_URL;

export const API_URL = ENV_API_URL ? `${ENV_API_URL}` : 'http:localhost:3002';
